import gql from 'graphql-tag'

export default {
  getNetworkActiveStock() {
    return {
      query: gql`
        query($bizmonId: Int, $graphType: String!, $graphTimeRange: String) {
          getNetworkActiveStock(bizmon_id: $bizmonId) {
            graph(type: $graphType, time_range: $graphTimeRange) {
              title
              data
            }
          }
        }
      `,
      skip() {
        return !this.bizonId
      },
      variables() {
        return {
          bizmonId: this.bizonId,
          graphType: 'last_mile',
          graphTimeRange: '1w'
        }
      }
    }
  }
}
